import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { AnimatedOnScroll } from "react-animated-css-onscroll";

function Why({ language }) {
  const { t } = useTranslation();

  return (
    <section id="why">
      <div className={`${"wholeWhy"} ${language == "ar" ? "ar" : ""}`}>
        <div className="whyContent">
          <AnimatedOnScroll animationIn="fadeInRight" animationInDelay="500">
            <div className="aboutRightTitle">
              <StaticImage width={20} src="../images/Arrow.svg" alt="arrow" />
              <h1>{t("whysection")}</h1>
            </div>{" "}
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInRight" animationInDelay="500">
            <p>{t("whyContentOne")}</p>
            <p>{t("whyContentTwo")}</p>
          </AnimatedOnScroll>
        </div>
        <div className="whyIcons">
          <div className="singleWhyIcons">
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <StaticImage width={100} src="../images/why2.svg" alt="why2" />
            </AnimatedOnScroll>
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <h1>{t("solutions")}</h1>
            </AnimatedOnScroll>
          </div>
          <div className="singleWhyIcons">
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <StaticImage
                width={100}
                src="../images/whyThoughts.svg"
                alt="why"
              />{" "}
            </AnimatedOnScroll>
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <h1>{t("thoughts")}</h1>
            </AnimatedOnScroll>
          </div>
          <div className="singleWhyIcons">
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <StaticImage width={100} src="../images/why3.svg" alt="why3" />
            </AnimatedOnScroll>
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <h1>{t("pro")}</h1>
            </AnimatedOnScroll>
          </div>
          <div className="singleWhyIcons">
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <StaticImage width={100} src="../images/why4.svg" alt="why4" />
            </AnimatedOnScroll>
            <AnimatedOnScroll animationIn="fadeInLeft" animationInDelay="500">
              <h1>{t("designContent")}</h1>
            </AnimatedOnScroll>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Why;
